import { inject,Injectable } from '@angular/core';
import { combineLatestWith, Observable } from 'rxjs';
import { map } from 'rxjs/operators';

import { AuthorizationService } from 'app/shared/authentication';

import { buildNavigation } from './build-navigation';
import { NavigationBuilderService } from './navigation-builder.service';
import { Navigation } from './navigation-types';
import { ViewContextService } from './view-context.service';

@Injectable({
    providedIn: 'root'
})
export class NavigationService {
    private readonly viewContextService = inject(ViewContextService);
    private readonly authorizationService = inject(AuthorizationService);
    private readonly navigationBuilderService = inject(NavigationBuilderService)

    public navigation$: Observable<Navigation>;

    constructor() {
        this.navigation$ = this.viewContextService.context$
            .pipe(
                combineLatestWith(this.authorizationService.authorizationContext()),
                map(([viewContext, authorizationContext]) => {
                    return buildNavigation(viewContext, authorizationContext, this.navigationBuilderService);
                })
            );
    }

}
